<template>
    <div>
        <el-row style="display: flex;margin-bottom: 10px;">
            <el-col :span="18" class='flex'>
                <el-select v-model='yusSubscribe' @change="parsch()" size="small" clearable placeholder="请选择订阅状态">
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-col>
            <el-col>
                <el-button v-if="getUserServerListSync" @click="user()"
                    size='small' type="primary" style="float:right" icon='el-icon-circle-plus'>同步公众号用户
                </el-button>
            </el-col>
        </el-row>
        <div>
            <myform :viewobj='{
                addYcVisitorQuestionTopicClass: ["新增拜访题目分类", "el-icon-circle-plus"],
                updateYcVisitorQuestionTopicClass: ["修改拜访题目分类", "el-icon-edit-outline"],
                $succeed$: getUserServerList
            }' @confirm='myform' @close='$form("addYcVisitorQuestionTopicClass", "reset")'>


                <hide slot='yvqtcId' />
            </myform>
            <mytable :tableColums='tableColums_getUserServerList' api='getUserServerList'
                xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
            </mytable>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            theProjectId: 0,
            value: '',
            form: {
                projectId: '',

            },
            tableColums_getUserServerList: {
                $selection: false,

                // oiType: '限制字段key',

                nickname: '昵称',
                yusOpenid: 'openid',
                yusUnionid: 'unionid',
                yusSubscribe: '是否关注',
                yusSubscribeTime: '关注时间',
                yusRemark: '公众号运营者对粉丝的备注',
                yusSubscribeScene: '关注渠道',
                createtime: '创建时间',
               
            }
        }
    },
    methods: {
        parsch() {
            this.getUserServerList({
                yusSubscribe: this.yusSubscribe
            });
        },
        user() {
            this.getUserServerListSync();
        },
        myform(submit, Myformdata) {
            submit();
        },

    },
    created() {
        this.getUserServerList();
    },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/ClassManagement/GZHuser.vue